import React from 'react';
import SubPageTemplate from '../components/SubPageTemplate';

const SolutionE = () => {
  const features = [
    { title: 'Process Automation', description: 'Eliminate repetitive manual work' },
    { title: 'Workflow Optimization', description: 'Smarter handoffs across teams' },
    { title: 'Resource Allocation', description: 'Right resources, right priorities' },
    { title: 'Supply Chain Intelligence', description: 'Visibility from end to end' },
    { title: 'Quality Assurance', description: 'Consistent standards at scale' },
    { title: 'Operational Analytics', description: 'Real-time performance signals' },
  ];

  return (
    <SubPageTemplate
      title="Operations"
      description="Streamlined operations that bring clarity, control, and intelligent flow to every process."
      features={features}
    />
  );
};

export default SolutionE;
